// src/layouts/autenticacion/usuarios/services/users.js
import api from "services/api";

const ENDPOINT = "/user";

function normalizeList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.page)) return data.page;
  if (Array.isArray(data?.data)) return data.data;
  return [];
}

function normalizeOne(data) {
  return data?.data ?? data ?? {};
}


export async function listUsers(params = null) {
  const { data } = await api.get(ENDPOINT, params ? { params } : undefined);

  const rows =
    Array.isArray(data?.page)    ? data.page :
    Array.isArray(data?.rows)    ? data.rows :
    Array.isArray(data?.data)    ? data.data :
    Array.isArray(data?.results) ? data.results :
    Array.isArray(data)          ? data :
    [];

  const total =
    typeof data?.total === "number" ? data.total :
    typeof data?.count === "number" ? data.count :
    rows.length;

  return { total, rows };
}

export async function getUser(id) {
  const { data } = await api.get(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return normalizeOne(data);
}

export async function createUser(payload) {
  const { data } = await api.post(ENDPOINT, payload);
  return normalizeOne(data);
}

export async function updateUser(id, payload) {
  const { data } = await api.put(`${ENDPOINT}/${encodeURIComponent(id)}`, payload);
  return normalizeOne(data);
}

export async function deleteUser(id) {
  const { data } = await api.delete(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return normalizeOne(data);
}

/**
 * Actualiza la contraseña usando la KEY de recuperación.
 * Ajusta el endpoint o payload si tu backend usa otros nombres.
 */
export async function recoverPassword({ key, password, repeatPassword }) {
  // El backend espera PUT /auth/recovery con { password, repeatPassword, key }
  const { data } = await api.put("/auth/recovery", {
    key,
    password,
    repeatPassword, // 👈 obligatorio con ese nombre exacto
  });
  return data;
}

/** Envía el correo de reset de contraseña */
export async function requestRecoveryEmail(email) {
  const url = "/auth/reset";
  try {
    const { data } = await api.put(url, { email });
    return data;
  } catch (e) {
    const status = e?.response?.status;
    const msg =
      e?.response?.data?.message ||
      (status ? `HTTP ${status}` : e.message || "Error de red");
    console.error("[ForgotPassword] ERROR", msg);
    throw new Error(msg);
  }
}


// (Opcional) export agrupado
export default { listUsers, getUser, createUser, updateUser, deleteUser };